function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { j as o } from "./index.es33.js";
import { clsx as b } from "./index.es105.js";
import { useState as G, useRef as x } from "react";
import { Typography as J } from "./index.es35.js";
import "./index.es36.js";
import { inputSelectors as K } from "./index.es107.js";
import "./index.es7.js";
import "./index.es133.js";
import "react-dom";
import { useClickAway as Q } from "./index.es130.js";
import "./index.es134.js";
import "./index.es132.js";
import "./index.es106.js";
import "./index.es13.js";
import "nanoid";
import "./index.es15.js";
import "./index.es135.js";
import { PopupMenu as M } from "./index.es136.js";
import { VariableIcon as X } from "./index.es415.js";
import { useActiveVariable as Y } from "./index.es416.js";
import { useVariableHover as Z } from "./index.es417.js";
import { useVariableModal as $ } from "./index.es418.js";
import { useValidation as U } from "./index.es419.js";
import { useTextareaPopupPosition as oo } from "./index.es420.js";
import { filterOptions as eo, formatValue as ro, calculatePopupPositionStyles as to, flatOptions as ao } from "./index.es421.js";
import { VariableModal as po } from "./index.es422.js";
import { usePopupPosition as io } from "./index.es164.js";
import so from "./index.es111.js";
import e from "./index.es423.js";
var Wo = function Wo(_ref) {
  var c = _ref.value,
    r = _ref.options,
    t = _ref.mirrorRef,
    u = _ref.textareaRef,
    a = _ref.isDisabled,
    C = _ref.isError,
    f = _ref.isFocused,
    O = _ref.children,
    j = _ref.noOptionsText,
    y = _ref.selectedValues,
    k = _ref.onAddVariable,
    d = _ref.isAddVariablePending,
    w = _ref.onChange,
    h = _ref.onOptionClick,
    S = _ref.validate,
    p = _ref.isPopupPositionUnderVariable,
    P = _ref.popupAlignment,
    g = _ref.isEmoji;
  var _G = G(!1),
    _G2 = _slicedToArray(_G, 2),
    i = _G2[0],
    v = _G2[1],
    s = x(null),
    l = x(null),
    _Z = Z(t),
    A = _Z.onMouseOver,
    H = _Z.onMouseLeave,
    _U = U(t, r, S),
    V = _U.validateErrors,
    _Y = Y({
      textareaRef: u,
      mirrorRef: t,
      value: c,
      setPopupOpen: v,
      onChange: w,
      onOptionClick: h,
      validateErrors: V,
      isPopupPositionUnderVariable: p,
      isFocused: f
    }),
    n = _Y.variable,
    N = _Y.activeVariableRef,
    E = _Y.onVariableClick,
    I = _Y.onVariableIconClick,
    L = _Y.onPopupClose,
    T = _Y.onPopupOptionClick,
    B = _Y.insertVariable,
    W = _Y.resetActiveVariable,
    _$ = $({
      setPopupOpen: v,
      onAddVariable: k,
      insertVariable: B,
      resetActiveVariable: W,
      validateErrors: V,
      isAddVariablePending: d,
      textareaRef: u
    }),
    _ = _$.isModalOpen,
    F = _$.onAddCustomVariable,
    R = _$.onVariableModalClose,
    q = _$.onVariableModalOpen;
  io({
    isOpen: i,
    popupRef: s,
    isPopupPositionUnderVariable: p
  }), oo({
    isOpen: i,
    popupRef: s,
    isPopupPositionUnderVariable: p,
    variable: n
  }), Q(s, function (m) {
    l.current && l.current.contains(m.target) || L();
  });
  var z = eo(n, r),
    D = ro(c, r);
  return o.jsxs(o.Fragment, {
    children: [o.jsxs("label", {
      className: b(so.wrapper, e.wrapper, K.classNames.wrapper, _defineProperty(_defineProperty(_defineProperty({}, e.wrapperFocused, f), e.wrapperWithError, C), e.wrapperDisabled, a)),
      ref: l,
      onMouseMove: a ? void 0 : A,
      onMouseLeave: a ? void 0 : H,
      onClick: E,
      children: [o.jsx(J.Body2, {
        ref: t,
        as: "div",
        className: b(e.mirror, _defineProperty({}, e.emoji, g)),
        dangerouslySetInnerHTML: {
          __html: D
        }
      }), O, o.jsx(X, {
        onClick: I,
        isDisabled: a,
        isActive: !!i
      })]
    }), i && o.jsx("div", {
      onMouseDown: function onMouseDown(m) {
        return m.preventDefault();
      },
      children: o.jsx(M, {
        header: o.jsx(M.VariableHeader, {}),
        popupRef: s,
        options: z,
        noOptionsText: j,
        onHeaderClick: q,
        onOptionClick: T,
        selectedValues: y,
        popupPositionStyles: to({
          activeVariableRef: N,
          isPopupPositionUnderVariable: p,
          popupAlignment: P
        })
      })
    }), _ && o.jsx(po, {
      defaultName: n,
      existingVariables: ao(r),
      onClose: R,
      onSave: F,
      isAddVariablePending: d
    })]
  });
};
export { Wo as VariableWrapper };